module.exports = __webpack_public_path__ + "img/blackRules.df8bafcb.png";